/*
  Note: this will be used to render a container that will then recieve a portal of the
  SignInMenu
*/
export default function MobileSignInMenu() {
  return null;
}
